import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from 'components/atoms/input-duration';
import { MainValue, Value } from '../components';
import { AsPlanned } from './as-planned-base';
import { WidgetDataColour } from './colours';

const AsPlannedHour: FC = () => (
  <AsPlanned translationKey="reports.project_performance.widget.as_planned_hours" />
);

const hoursRenderer = (result) => {
  const color = result > 0 ? WidgetDataColour.Red : WidgetDataColour.Green;

  return <MainValue color={color}>{format('hh', Math.abs(result))}</MainValue>;
};

export const HoursData: FC<{ value: number }> = ({ value }) => {
  const key =
    value > 0
      ? 'reports.project_performance.widget.hours_over'
      : 'reports.project_performance.widget.hours_under';

  return value === 0 ? (
    <AsPlannedHour />
  ) : (
    <Value>
      <FormattedMessage id={key} values={{ value: hoursRenderer(value) }} />
    </Value>
  );
};
